export default "__VITE_ASSET__CZOFUGhv__"